/***************************************************************
6/9/2017
Alexander Self
List of urls for side nav
***************************************************************/
import { browserHistory } from 'react-router';
import React from 'react';
const $ = window.$;


const UrlList = ({ listItems, id, _class }) => {
  $(document).ready(function(){
    $('.tooltipped').tooltip({delay: 50});
  });
  return (
    <div>
      <ul id={id} className={`collection product-report-ul z-depth-4`}>
        {
          listItems.map((item, i) => (
            <li key={`${item}${i}`} className={`collection-item tooltipped product-report-tab`} onClick={() => browserHistory.push(`${item.url}`)}
              data-position="right" data-delay="50" data-tooltip={item.name}>
              <div className="product-tab-display-desktop-tablet"><br /><br /><br /><br /><br /><br /></div>
              <span className="product-report-text">{ item.name }</span>
            </li>
          ))
        }
      </ul>
    </div>
  )
};

export default UrlList;



// WEBPACK FOOTER //
// ./src/cultivation/components/url_list.js